// Utils
import { getColorCSSVar, getImgCSSVar } from './getCSSVarUtil';

// Constants
import BRANDING from '../constants/brandingConst';
import BRANDING_KEYS from '../constants/brandingKeysConst';
import BRANDING_CSS_VARS from '../constants/brandingCSSVarsConst';
import { getAttributeData } from './brandingUtil';

const getBackgroundColorTheme = (attributes) => {
    const { BODY_BG_COLOR_START, BODY_BG_COLOR_END } = BRANDING;

    return {
        ...getColorCSSVar(
            attributes,
            BODY_BG_COLOR_START,
            BRANDING_CSS_VARS[BODY_BG_COLOR_START],
        ),
        ...getColorCSSVar(
            attributes,
            BODY_BG_COLOR_END,
            BRANDING_CSS_VARS[BODY_BG_COLOR_END],
        ),
    };
};

const getBackgroundTheme = (attributes) => {
    const {
        BODY_BG_IMG,
        BODY_BG_IMG_FITS_TO_AREA,
        BODY_BG_IMG_POSITION,
        BODY_BG_IMG_REPEAT,
        BODY_BG_IMG_SIZE,
        BODY_BG_COLOR_START,
        BODY_BG,
    } = BRANDING;
    const variables = {
        ...getImgCSSVar(
            attributes,
            BODY_BG_IMG,
            BRANDING_CSS_VARS[BODY_BG_IMG],
        ),
    };

    // Get BG Image URL
    const { value: bgImgURL } = getAttributeData(
        attributes,
        BRANDING_KEYS[BODY_BG_IMG],
    );

    if (!bgImgURL) {
        variables[
            BRANDING_CSS_VARS[BODY_BG]
        ] = `var(${BRANDING_CSS_VARS[BODY_BG_COLOR_START]})`;
    } else {
        // Does image fill background?
        const { value: fillsBG } = getAttributeData(
            attributes,
            BRANDING_KEYS[BODY_BG_IMG_FITS_TO_AREA],
        );

        if (fillsBG) {
            // Set Background Size Variable to 'cover'
            variables[BRANDING_CSS_VARS[BODY_BG_IMG_SIZE]] = 'cover';
            // Set Repeat Variable to 'no-repeat'
            variables[BRANDING_CSS_VARS[BODY_BG_IMG_REPEAT]] = 'no-repeat';
            // Set Position to 'center'
            variables[BRANDING_CSS_VARS[BODY_BG_IMG_POSITION]] = 'center';
        } else {
            // Get Background Repeat
            const { value: repeat } = getAttributeData(
                attributes,
                BRANDING_KEYS[BODY_BG_IMG_REPEAT],
            );
            // Set Background Repeat Variable
            variables[BRANDING_CSS_VARS[BODY_BG_IMG_REPEAT]] = repeat;

            // Get Background Position
            const { value: bgPosition } = getAttributeData(
                attributes,
                BRANDING_KEYS[BODY_BG_IMG_POSITION],
            );
            // Set Background Position Variable
            variables[BRANDING_CSS_VARS[BODY_BG_IMG_POSITION]] = bgPosition;
        }

        // Set Background Variable to Background With Image Variable
        variables[BRANDING_CSS_VARS[BODY_BG]] =
            'var(--global-body-bg-with-img)';
    }

    return variables;
};

const bodyThemeUtil = (attributes) => {
    return {
        ...getBackgroundColorTheme(attributes),
        ...getBackgroundTheme(attributes),
    };
};

export default bodyThemeUtil;
